import React from 'react';
import {
  Devices,
  Group,
  AvTimer,
  Assignment,
  TrendingUp,
} from '@material-ui/icons';
import {
  ROLE_ADMIN,
  ROLE_PHYSICIAN,
  ROLE_SALES,
} from '../constants/roles';
import {
  PATHS,
  DASHBOARD,
  USERS,
  REPORTS,
  ACTIVITY,
  WEBSITE,
} from '../constants/paths';

let routes = [];
routes = PATHS.map((item) => {
  let external = false;
  let icon = null;
  switch (item.key) {
    case DASHBOARD:
      icon = <AvTimer />;
      break;
    case USERS:
      icon = <Group />;
      break;
    case REPORTS:
      icon = <Assignment />;
      break;
    case ACTIVITY:
      icon = <TrendingUp />;
      break;
    case WEBSITE:
      icon = <Devices />;
      external = true;
      break;
    default:
      icon = null;
      break;
  }
  return Object.assign({ icon, external }, item);
});


const defaultRoutes = routes.reduce((newRoutes, route) => {
  if (route.key === REPORTS || route.key === WEBSITE) {
    newRoutes.push(route);
  }
  return newRoutes;
}, []);

export default {
  [ROLE_ADMIN]: routes,
  [ROLE_PHYSICIAN]: defaultRoutes,
  [ROLE_SALES]: defaultRoutes,
};



// WEBPACK FOOTER //
// ./src/navigation/routes.js